import React, { useMemo } from "react";
import { AreaChart } from "../../../../../../../views/app/dashboards/components/charts";
import { Card, CardBody, CardTitle } from "reactstrap";
import moment from "moment";
import { ThemeColors } from "../../../../../../../helpers/ThemeColors";
import { generateCompleteDateRange, getDateLabel } from "./dateRangeUtils";

const hexToRgba = (hex, alpha = 0.12) => {
  if (!hex) return `rgba(0,0,0,${alpha})`;

  let c = hex.replace("#", "");

  if (c.length === 3) {
    c = c.split("").map(x => x + x).join("");
  }

  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};


const WhatsAppGraph = ({ apiData = [], fromDate = null, toDate = null, isYearMonthView = false }) => {
  const colors = ThemeColors();

  const chartData = useMemo(() => {
    if (!Array.isArray(apiData) || apiData.length === 0) {
      return null;
    }

    const completeData = generateCompleteDateRange(apiData, fromDate, toDate, isYearMonthView);

    const labels = [];
    const data = [];

    const sortedData = [...completeData].sort((a, b) => new Date(a.dates) - new Date(b.dates));

    sortedData.forEach((item) => {
      labels.push(getDateLabel(item.dates, isYearMonthView));

      let count = 0;
      item.channels?.forEach((ch) => {
        if (ch.channel?.toLowerCase() === "whatsapp") count = ch.count;
      });

      data.push(count);
    });
    const themeColor = colors.themeColor1;


    return {
      labels,
      datasets: [
        {
          label: "WhatsApp",
          data: data,
          borderColor: themeColor,
          pointBackgroundColor: colors.foregroundColor,
          pointBorderColor: themeColor,
          pointHoverBackgroundColor: themeColor,
          pointHoverBorderColor: colors.foregroundColor,
          pointRadius: 4,
          pointBorderWidth: 2,
          pointHoverRadius: 5,
          fill: true,
          borderWidth: 2,
          backgroundColor: hexToRgba(themeColor, 0.12),

        },
      ],
    };
  }, [apiData, fromDate, toDate, isYearMonthView]);

  if (!chartData) {
    return (
      <Card className="mb-3">
        <CardTitle tag="h6" className="mb-3 ml-3" style={{ marginTop: '20px' }}>
          WhatsApp Engagement
        </CardTitle>
        <CardBody>
          <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
            No data available
          </div>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className="mb-3">
      <CardTitle tag="h6" className="mb-3 ml-3" style={{ marginTop: '20px' }}>
        WhatsApp Engagement
      </CardTitle>
      <CardBody>
        <div style={{ height: 300 }}>
          <AreaChart data={chartData} />
        </div>
      </CardBody>
    </Card>
  );
};

export default WhatsAppGraph;